import * as R from 'ramda';
import angular from 'angular';

export default function AssetController(
  $q,
  $rootScope,
  $scope,

  alerts,
  confirmDialog,
  editAssetDialog,
  editRiskDialog,
  loaderService,
  assetDataService,
  riskDataService,
  assetSharedModelService,
  riskSharedModelService,
  ssDialogService,
  userService,
  deleteAssetConfirmDialog,
  praDataService,
  syncAssetConfirmDialog,
  copyAssetDialog,
) {
  const vm = this;

  vm.canExpand = true;
  vm.asset.isExpanded = false;
  vm.asset.hasData = false;
  
  vm.handleAddRiskClick = _handleAddRiskClick;
  vm.handleEditClick = _handleEditClick;
  vm.handleUnassignClick = _handleUnassignClick;
  vm.handleDeleteClick = _handleDeleteClick;
  vm.handleExpandControlClick = _handleExpandControlClick;
  vm.handleAssignAssetChange = _handleAssignAssetChange;
  vm.handleBulkDeleteChange = _handleBulkDeleteChange;
  vm.handleBulkChangeTypeChange = _handleBulkChangeTypeChange;
  vm.handleSyncClick = _handleSyncClick;
  vm.handleCopyClick = _handleCopyClick;

  _activate();

  function _activate() {
    if (vm.assignAsset === true) {
      vm.tooltipAppendToSelector = '#assignAssetDialog';
    } else if (vm.isEditProcessDialog === true) {
      vm.tooltipAppendToSelector = '#editProcessDialog';
    }
    _initTooltips();
    _initCriticality();
    _initPermissions();
    $scope.$on('refreshAssetRisks', (event, opt) => {
      if (opt.asset.customerAssetId === vm.asset.customerAssetId) {
        loaderService.showViewLoader = true;
        _getAssignedRisks().then(() => {
          loaderService.showViewLoader = false;
        });
      }
    });
  }

  function _handleAssignAssetChange() {
    $rootScope.$broadcast('refreshAssignAssetCount', { assetType: vm.assetType });
  }

  function _handleBulkDeleteChange() {
    $rootScope.$broadcast('selectBulkAssetChange');
  }

  function _handleBulkChangeTypeChange() {
    $rootScope.$broadcast('selectBulkAssetTypeChange');
  }

  function _initTooltips() {
    if (vm.asset) {
      vm.asset.assetDataTypeTooltip = 'This is';
      switch (vm.asset.assetDataTypeId) {
        case 1:
          vm.asset.assetDataTypeTooltip += ' a Physical Asset.';
          break;
        case 2:
          vm.asset.assetDataTypeTooltip += ' an Electronic Asset.';
          break;
        case 3:
          vm.asset.assetDataTypeTooltip += ' both a Physical and Electronic Asset. ';
          break;
        default:
          vm.asset.assetDataTypeTooltip = null;
      }
    }
  }

  function _initCriticality() {
    if (vm.asset) {
      const classMappings = {
        1: 'status-tier-bar--terrible',
        2: 'status-tier-bar--bad',
        3: 'status-tier-bar--caution',
        4: 'status-tier-bar--good',
        5: 'status-tier-bar--great',
      };
      vm.asset.criticalityCssClass = classMappings[vm.asset.assetCriticalityId];
      vm.asset.assetCriticality = assetSharedModelService.AssetCriticalities.find(
        assetCriticality => assetCriticality.assetCriticalityId === vm.asset.assetCriticalityId,
      );
    }
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then(permissions => {
      vm.permissions = permissions;
    });
  }

  function _handleAddRiskClick($event) {
    loaderService.showViewLoader = true;

    const risk = { customerRiskId: 0 };
    $q.all([
      // riskDataService.getRiskTypes(),
      // assetDataService.getAssets(),
      riskDataService.getRiskById(risk.customerRiskId),
      riskDataService.getRiskTypeDefaults(),
    ]).then(response => {
      risk.riskOnsetId = response[1].data.riskOnset.riskOnsetId;
      risk.riskForewarningId = response[1].data.riskForewarning.riskForewarningId;
      risk.riskDurationId = response[1].data.riskDuration.riskDurationId;
      risk.riskDataConfidentialityId = response[1].data.riskDataConfidentiality.riskDataConfidentialityId;
      risk.riskDataIntegrityId = response[1].data.riskDataIntegrity.riskDataIntegrityId;
      risk.riskDataAvailabilityId = response[1].data.riskDataAvailability.riskDataAvailabilityId;
      risk.riskDirectionId = response[1].data.riskDirection.riskDirectionId;
      risk.riskTrendingId = response[1].data.riskTrending.riskTrendingId;
      risk.riskAssessmentFrequencyId = response[1].data.riskAssessmentFrequency.riskAssessmentFrequencyId;
      risk.riskProbabilityId = response[1].data.riskProbability.riskProbabilityId;
      risk.riskClassificationId = response[1].data.riskClassification.riskClassificationId;
      ssDialogService.dialogs.riskAdmin.editRiskDialog = ssDialogService.alert(
        editRiskDialog.getOptions($event, {
          risk,
          riskTypes: response[0].data.CustomerRiskTypes,
          preselectedAssetId: vm.asset.customerAssetId,
          assets: response[0].data.CustomerAssetData,
          asset: vm.asset,
          riskOnsets: riskSharedModelService.RiskOnsets,
          riskForewarnings: riskSharedModelService.RiskForewarnings,
          riskDurations: riskSharedModelService.RiskDurations,
          riskDataConfidentialities: riskSharedModelService.RiskDataConfidentialities,
          riskDataIntegrities: riskSharedModelService.RiskDataIntegrities,
          riskDataAvailabilities: riskSharedModelService.RiskDataAvailabilities,
          riskDirections: riskSharedModelService.RiskDirections,
          riskTrendings: riskSharedModelService.RiskTrendings,
          riskAssessmentFrequencies: riskSharedModelService.RiskAssessmentFrequencies,
          riskProbabilities: riskSharedModelService.RiskProbabilities,
          riskClassifications: riskSharedModelService.RiskClassifications,
          // updateCallBack: _handleUpdateAssets,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.riskAdmin.editRiskDialog);
      loaderService.showViewLoader = false;
    });
  }

  function _handleEditClick($event) {
    loaderService.showViewLoader = true;
    assetDataService.getAsset(vm.asset.customerAssetId).then(getAssetResponse => {
      vm.asset = getAssetResponse.data;
      _initCriticality();
      vm.asset.customerRisks.forEach(risk => {
        riskSharedModelService.transformRiskTop(risk);
        risk = riskSharedModelService.addSeverityDescriptionsToRiskType(risk);
        risk = riskSharedModelService.transformMeterStatusToRiskType(risk);
        risk = riskSharedModelService.addColorToProbability(risk);
      });

      loaderService.showViewLoader = false;
      ssDialogService.dialogs.assetAdmin.editAssetDialog = ssDialogService.alert(
        editAssetDialog.getOptions($event, {
          asset: vm.asset,
          assetCriticalities: assetSharedModelService.AssetCriticalities,
          assetDataTypes: assetSharedModelService.AssetDataTypes,
          assetDataUses: assetSharedModelService.AssetDataUses,
          assetTypes: assetSharedModelService.AssetTypes,
          updateCallBack: _handleUpdateAssets,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.assetAdmin.editAssetDialog);
    });
  }

  function _handleUpdateAssets() {
    _broadcastEvents();
  }

  function _handleUnassignClick($event) {
    ssDialogService.dialogs.pra.unassignProcessAssetDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Unassign Asset?',
        message: `Are you sure you want to unassign the Asset, "${vm.asset.name}" from the Process "${vm.process.name}"?`, // eslint-disable-line
        handleYesClick: _handleConfirmUnassignClick,
        handleNoClick: _closeConfirmUnassignDialog,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.pra.unassignProcessAssetDialog);
  }

  function _handleConfirmUnassignClick() {
    loaderService.showViewLoader = true;
    praDataService.unassignAssetFromProcess(vm.process.assessmentProcessId, vm.asset.customerAssetId).then(() => {
      alerts.success(`The Asset "${vm.asset.name}" has been successfully unassigned.`);
      loaderService.showViewLoader = false;
      _broadcastEvents();
      _closeConfirmUnassignDialog();
    });
  }

  function _closeConfirmUnassignDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pra.unassignProcessAssetDialog);
  }

  function _handleDeleteClick($event) {
    ssDialogService.dialogs.assetAdmin.deleteAssetDialog = ssDialogService.alert(
      deleteAssetConfirmDialog.getOptions($event, {
        asset: vm.asset,
        process: vm.process,
        isEditProcessDialog: vm.isEditProcessDialog,
        assignAsset: vm.assignAsset,
        isPraProcessMain: vm.isPraProcessMain,
        updateCallBack: _broadcastEvents,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.assetAdmin.deleteAssetDialog);
  }

  function _handleSyncClick($event) {
    ssDialogService.dialogs.assetAdmin.syncAssetDialog = ssDialogService.alert(
      syncAssetConfirmDialog.getOptions($event, {
        asset: vm.asset,
        assetType: vm.assetType,
        isMultipleAssets: false,
        updateCallBack: _broadcastEvents,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.assetAdmin.syncAssetDialog);
  }

  function _handleCopyClick($event) {
    loaderService.showViewLoader = true;
      ssDialogService.dialogs.assetAdmin.copyAssetDialog = ssDialogService.alert(
        copyAssetDialog.getOptions($event, {
          asset: vm.asset,
          updateCallBack: _broadcastEvents,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.assetAdmin.copyAssetDialog);
      loaderService.showViewLoader = false;
  }

  function _broadcastEvents() {
    if (vm.isEditProcessDialog === true) {
      $rootScope.$broadcast('refreshAssessmentAssets', { assetType: vm.assetType });
    } else if (vm.assignAsset === true) {
      $rootScope.$broadcast('refreshAssignAssets');
    } else if (vm.isPraProcessMain === true) {
      $rootScope.$broadcast('refreshMainAssessmentProcess', { process: vm.process });
    } else {
      $rootScope.$broadcast('refreshAssets', { assetType: vm.assetType });
    }
  }

  function _handleExpandControlClick() {
    if (!vm.asset.hasData) {
      assetDataService.getAsset(vm.asset.customerAssetId).then(getAssetResponse => {
        angular.merge(vm.asset, getAssetResponse.data);
        vm.asset.customerRisks.forEach(risk => {
          riskSharedModelService.transformRiskTop(risk);
          risk = riskSharedModelService.addSeverityDescriptionsToRiskType(risk);
          risk = riskSharedModelService.transformMeterStatusToRiskType(risk);
          risk = riskSharedModelService.addColorToProbability(risk);
        });
        vm.asset.hasData = true;
      });
    }
    vm.asset.isExpanded = !vm.asset.isExpanded;
  }

  function _getAssignedRisks() {
    return assetDataService.getAsset(vm.asset.customerAssetId).then(response => {
      if (!response.data) {
        alerts.error('Error occurred while get the asset.');
      } else {
        alerts.success('The risk has been retrieved successfully.');
        vm.asset = {
          ...vm.asset,
          ...response.data,
        };
        _initCriticality();
        vm.asset.customerAssetCustomerRisks = assetSharedModelService.addSeverityDescriptionsToRisks(
          vm.asset.customerRisks,
        );
        const _customerRisks = [];
        R.forEach(item => {
          riskDataService.getRisk(item.customerRiskId).then(response1 => {
            if (!response1.data) {
              alerts.error('Error occurred while get the risk.');
            } else {
              _customerRisks.push(angular.copy(response1.data));
            }
            loaderService.showViewLoader = false;
          });
        }, vm.asset.customerRisks);
        vm.asset.customerRisks = _customerRisks;
      }
    });
  }
}

AssetController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'confirmDialog',
  'editAssetDialog',
  'editRiskDialog',
  'loaderService',
  'assetDataService',
  'riskDataService',
  'assetSharedModelService',
  'riskSharedModelService',
  'ssDialogService',
  'userService',
  'deleteAssetConfirmDialog',
  'praDataService',
  'syncAssetConfirmDialog',
  'copyAssetDialog',
];
